import { z } from 'zod';

/**
 * @openapi
 * components:
 *   schemas:
 *     CreateOrgDto:
 *       type: object
 *       properties:
 *         name:
 *           type: string
 *           description: The name of the organization
 *       required:
 *         - name
 */
export const createOrgDto = z.object({
  name: z.string().min(1),
});

export type CreateOrgDto = z.infer<typeof createOrgDto>;
